import React from 'react';
import styles from './TypeformWidget.module.scss';
import { Widget } from '@typeform/embed-react';

const TypeformWidget = ({ formId }) => {
  return <Widget id={formId} className={styles.form} />;
};

export default TypeformWidget;
